import React from "react";
import {Box, IconButton} from "@mui/material";
import {alpha} from "@mui/material/styles";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CloseIcon from "@mui/icons-material/Close";

export function SpreadsheetActionNavigation({onBack, onClose}) {
  return <Box sx={{display: 'flex', alignItems: 'center', gap: 0.25}}>
    <IconButton size="small" onClick={onBack} aria-label="Back to actions">
      <ArrowBackIosNewIcon fontSize="small" />
    </IconButton>
    <IconButton size="small" onClick={onClose} aria-label="Close actions">
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>;
}

export function actionSubmitButtonSx(theme) {
  return {
    flex: '0 0 auto', minWidth: 112, width: 112, height: 40, px: 2,
    borderRadius: '10px', textTransform: 'none', fontWeight: 700,
    fontSize: 13, lineHeight: 1, whiteSpace: 'nowrap',
    bgcolor: theme.palette.primary.main, color: theme.palette.primary.contrastText,
    '&.Mui-disabled': {
      bgcolor: alpha(theme.palette.primary.main, 0.45),
      color: alpha(theme.palette.primary.contrastText || '#fff', 0.92),
    },
  };
}

/** FE #748: a submit button that carries its cost grows to a second line instead of overflowing. */
export function paidSubmitButtonSx(theme, cost) {
  const base = actionSubmitButtonSx(theme);
  if (!cost) return base;
  return {...base, width: 'auto', maxWidth: 200, height: 'auto', minHeight: 40, py: 0.75,
    whiteSpace: 'normal', flexDirection: 'column', lineHeight: 1.2, textAlign: 'center'};
}

/** The button label with its cost on a second line. Visual only: the credit banner announces the price. */
export function PaidButtonLabel({label, cost}) {
  return <>
    {label}
    {cost && <Box component="span" aria-hidden="true" data-testid="paid-button-cost"
      sx={{display: 'block', fontSize: 11, fontWeight: 500, opacity: 0.9}}>{` ${cost}`}</Box>}
  </>;
}
